<template>
  <div v-if="modal">
    <div id="modalCaixa" :class="{'is-pdv': isPdv}" class="modal-pdv modal-small show">
      <div class="modal-pdv-content">
        <div class="container-fluid">
          <h5 class="text-center font-weight-bold mb-1">NOVO CAIXA</h5>
          <hr>
          <div class="mb-2" v-if="admin">
            <label class="mb-0">Colaborador</label>
            <select class="form-control" v-model="dados.id_usuario" @change="$helpers.focusElement(input)">
              <option value="">Usuário atual</option>
              <option :value="u.id_usuario" v-for="u in usuarios">{{ u.nome }}</option>
            </select>
          </div>
          <div class="mb-2">
            <label class="mb-0">Valor Inicial</label>
            <money :id="input" v-model="dados.valor_inicial" @keyup.enter.native="registerCaixa" class="form-control"/>
          </div>
          <div class="alert alert-info mb-4">
            <i class="fa fa-info-circle mr-2"></i> Deixe zerado se não utilizar troco
          </div>
        </div>
        <div class="modal-content-footer bg-light border-top p-2 mt-3 d-flex justify-content-between">
          <button class="btn btn-dark p-3" @click="cancelar()">
            Cancelar
          </button>
          <button class="btn btn-success p-3 ml-auto" @click="registerCaixa" :disabled="load">
            <i class="fa fa-check"></i>
            {{load ? 'Aguarde..' : 'Confirmar'}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "caixa",
    props: ['admin', 'isPdv'],
    data() {
      return {
        token: localStorage.getItem('key'),
        modal: 0,
        input: this.$helpers.ID(),
        load: false,
        nextEl: null,
        dados: {
          id_usuario: '',
          valor_inicial: 0,
          id_empresa: null
        }
      }
    },

    methods: {
      toggleModal(m, callback) {
        this.modal = m;
        this.$nextTick(() => {
          this.$helpers.toggleModal(m, 'modalCaixa', this.toggleModal);

          if (m) {
            if (callback) callback();

          } else if (this.nextEl) {
            this.$helpers.focusElement(this.nextEl);
          }
        });
      },

      getUsuarios() {
        if (this.admin && !this.usuarios.length) {
          this.$req.buscarColaboradores(this, this.token);
        }
      },

      cancelar() {
        this.toggleModal(false);
      },

      registerCaixa() {
        if (this.load) {
          return;
        }

        this.load = true;
        this.$http.post('caixas/' + this.token, this.dados).then(res => {
          this.load = false;

          if (res.data && res.data.success) {
            this.toggleModal(false);
            this.$emit('finalizarVenda', res.data.id_caixa);

          } else {
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          }

        },res => {
          this.load = false;
          this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
        });
      },

      abrirCaixa(id_empresa, next) {
        this.dados.id_usuario = '';
        this.dados.valor_inicial = 0;
        this.dados.id_empresa = id_empresa || null;

        this.toggleModal(true, () => {
          this.getUsuarios();
          this.$helpers.focusElement(this.input);
        });

        this.nextEl = next || null;
      }
    },

    computed: {
      usuarios() {
        return this.$store.state.colaboradores.filter(c => ['1','2'].includes(c.id_funcao));
      }
    }
  }
</script>

<style scoped>
.modal-pdv .modal-pdv-content {
  margin-top: 72px;
}

@media (min-width: 992px) {
  .modal-pdv.is-pdv .modal-pdv-content {
    margin-top: 48px;

    max-width: 420px;
  }
}
</style>
